// WarehouseQuoteDetailEdit.tsx
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ServiceResponse } from '../../../../../app/services/shared/interfaces';
import ButtonCancelForm from '../../../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../../../components/buttons/ButtonSaveForm';
import useWarehouseQuoteDetailService from '../../../../../app/services/hooks/useWarehouseQuoteDetailService';
import { WarehouseQuoteDetailDataForm } from '../../../../../app/models/WareHouseQuoteDetail';
import WarehouseQuoteDetailForm from './forms/WareHouseQuoteDetailForms/WareHouseQuoteDetailForm';
import { Depot } from '../../../../../app/models/Depot';
import { Service } from '../../../../../app/models/Service';
import { Product } from '../../../../../app/models/Product';
import { Unit } from '../../../../../app/models/Unit';
import { Currency } from '../../../../../app/models/Currency';
import { QuoteDetailFormTypeEnum } from '../../../../../app/shared/enums';

interface Props {
    quoteId: number;
    // quoteDetail: WarehouseQuoteDetailDataForm;
    warehouseQuoteDetialId: number;
    onSaved: () => void;
    onCancel: () => void;
}

const WarehouseQuoteDetailEdit = ({ 
    quoteId,
    warehouseQuoteDetialId,
    onSaved,
    onCancel,
}: Props) => {
    const { editWarehouseQuoteDetail,updateWarehouseQuoteDetail, showStorageDataToWareHouseQuoteDetail } = useWarehouseQuoteDetailService();
    const [quoteDetailForm, setQuoteDetailForm] = useState<WarehouseQuoteDetailDataForm>({
        product_id: warehouseQuoteDetialId,
        free_days: 0
    });
    const [depots, setDepots] = useState<Depot[]>([]);
    const [disableStorage, setDisableStorage] = useState<boolean>(false);
    const [disableRate, setDisableRate] = useState<boolean>(false);
        
    const [services, setServices] = useState<Service[]>([]);
    const [products, setProducts] = useState<Product[]>([]);
    const [quantityUnits, setQuantityUnits] = useState<Unit[]>([]);
    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const [units, setUnits] = useState<Unit[]>([]);
    const [errorFields, setErrorFields] = useState<any>();

    const isWarehouseForm = services.find(s => s.id === quoteDetailForm.service_id)
        ?.quote_detail_form_type === QuoteDetailFormTypeEnum.WAREHOUSE;

    useEffect(() => {
            edit();
    }, [warehouseQuoteDetialId]);
        
    const edit = () => {
            editWarehouseQuoteDetail(warehouseQuoteDetialId, {
                onSuccess: (response: ServiceResponse) => {
                    setQuoteDetailForm( response.data.warehouse_quote_detail);
                    setServices(response.data.services);
                    setProducts(response.data.products);
                    setQuantityUnits(response.data.units);
                    setDepots(response.data.depots);
                    setCurrencies(response.data.currencies);
                    setUnits(response.data.units);
                    // setPackingTypes(response.data.packing_types);
                },
                onError: (response: ServiceResponse) => {
                    toast.error('Error al cargar almacenamiento');
                }
            });
        };
        const update = () => {
            // useSweetAlert().spinnerAlert('Actualizando...', 400);
            
            updateWarehouseQuoteDetail( warehouseQuoteDetialId,quoteDetailForm, {
                onSuccess: () => {
                    // useSweetAlert().closeSpinnerAlert();
                toast.success('Detalle actualizado correctamente');
                onSaved();
            },
            onError: (response: ServiceResponse) => {
                // useSweetAlert().closeSpinnerAlert();
                toast.error(response.message);
            }
        });
    };
    // Función para mapear los datos del API al formulario
    const mapStorageDataToForm = (storageData: any) => {
        const freeDaysData = storageData.free_days?.[0];
        const ratesData = storageData.rates?.[0];
        
        if (!freeDaysData && !ratesData) {
            return {}; // No hay datos para mapear
        }
        
        // Función helper para encontrar el ID de una unidad por nombre
        const findUnitIdByName = (unitName: string) => {
            const unit = units.find(u => u.name === unitName);
            return unit ? unit.id : 0;
        };

        // Función helper para encontrar el ID de una moneda por nombre
        const findCurrencyIdByName = (currencyName: string) => {
            const currency = currencies.find(c => c.name === currencyName);
            return currency ? currency.id : 0;
        };
        
        return {
            // Días libres
            free_days: freeDaysData?.free_days || 0,
            
            // Tarifa por ingreso
            container_entry_fee: ratesData?.container_entry_fee ? parseFloat(ratesData.container_entry_fee) : 0,
            container_entry_fee_currency_id: ratesData?.container_entry_fee_currency 
            ? findCurrencyIdByName(ratesData.container_entry_fee_currency) 
            : 0,
            container_entry_fee_unit_id: ratesData?.container_entry_fee_unit 
            ? findUnitIdByName(ratesData.container_entry_fee_unit) 
            : 0,
            
            // Tarifa por día de almacenaje
            daily_storage_fee: ratesData?.daily_storage_fee ? parseFloat(ratesData.daily_storage_fee) : 0,
            daily_storage_fee_currency_id: ratesData?.daily_storage_fee_currency 
            ? findCurrencyIdByName(ratesData.daily_storage_fee_currency) 
            : 0,
            daily_storage_fee_unit_id: ratesData?.daily_storage_fee_unit 
            ? findUnitIdByName(ratesData.daily_storage_fee_unit) 
            : 0,
            
            // Tarifa por salida
            container_exit_fee: ratesData?.container_exit_fee ? parseFloat(ratesData.container_exit_fee) : 0,
            container_exit_fee_currency_id: ratesData?.container_exit_fee_currency 
            ? findCurrencyIdByName(ratesData.container_exit_fee_currency) 
            : 0,
            container_exit_fee_unit_id: ratesData?.container_exit_fee_unit 
            ? findUnitIdByName(ratesData.container_exit_fee_unit) 
            : 0,
            
            // Comentarios adicionales
            comment: ratesData?.additional_comments || ''
        };
    };
    
    useEffect(() => {
        // Solo ejecutar si ambos valores están presentes y las listas de monedas/unidades están cargadas
        if (quoteDetailForm.depot_id && quoteDetailForm.product_id && currencies.length > 0 && units.length > 0) {
            showStorageDataToWareHouseQuoteDetail(quoteId, quoteDetailForm.depot_id, quoteDetailForm.product_id, {
                onSuccess: (response: ServiceResponse) => {
                    setErrorFields(undefined);
                    
                    // Mapear los datos del almacenamiento al formulario
                    const mappedStorageData = mapStorageDataToForm(response.data);
                    setDisableStorage(response.data.has_storage)
                    setDisableRate(response.data.has_rate)
                    
                    setQuoteDetailForm(prevForm => ({
                        ...prevForm,
                        ...mappedStorageData
                    }));
                },
                onError: (response: ServiceResponse) => {
                    // Si no se encuentran datos, limpiar los campos relacionados
                    setQuoteDetailForm(prevForm => ({
                        ...prevForm,
                        free_days: 0,
                        container_entry_fee: 0,
                        container_entry_fee_currency_id: 0,
                        container_entry_fee_unit_id: 0,
                        daily_storage_fee: 0,
                        daily_storage_fee_currency_id: 0,
                        daily_storage_fee_unit_id: 0,
                        container_exit_fee: 0,
                        container_exit_fee_currency_id: 0,
                        container_exit_fee_unit_id: 0,
                        comment: ''
                    }));
                }
            });
        }
    }, [quoteDetailForm.product_id, quoteDetailForm.depot_id, currencies.length, units.length]);

    return (
        <>
            <WarehouseQuoteDetailForm
                warehouseQuoteDetailForm={quoteDetailForm}
                setWarehouseQuoteDetailForm={setQuoteDetailForm}
                services={services}
                products={products}
                currencies={currencies}
                units={units}
                depots={depots}
                quantityUnits={units}
                disableUpdate={false}
                disableRate={disableRate}
                disableStorage={disableStorage}
                errorFields={errorFields}
                isWarehouseForm={isWarehouseForm}
            />
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto"><ButtonCancelForm callbackCancel={onCancel} /></div>
                <div className="col-auto"><ButtonSaveForm callbackSave={update} /></div>
            </div>
        </>
    );
};

export default WarehouseQuoteDetailEdit;
